import axios from "axios";
import { Cookies } from "react-cookie";
import { localStorageItemNames } from "../constants";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
});
// Request Interceptor
api.interceptors.request.use(
  (config) => {
    let cookies = new Cookies();
    const token = cookies.get(localStorageItemNames.TOKEN); // set the token for authenticated requests
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.validateStatus = (status) =>
      status === 200 || status === 201 || status === 204;

    if (config.url && config.url.startsWith(":")) {
      const cleanBaseURL = config.baseURL ? config.baseURL.replace(/\/+$/, "") : "";
      config.url = `${cleanBaseURL}${config.url}`;
      config.baseURL = "";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href = "/";
      localStorage.clear();
      removeUserCookies();
    } else if (error.toJSON()?.message === "Network Error") {
      console.error("Network error occurred:", error);
    }
    return Promise.reject(error);
  }
);

export { BASE_URL, IMAGE_URL };
export default api;



export const setUserCookies = (data) => {
  let cookies = new Cookies();
  cookies.set(localStorageItemNames.USER_ID, data?._id, { path: "/", expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) });
  cookies.set(localStorageItemNames.USER_EMAIL, data?.email_id, { path: "/", expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) });
  cookies.set(localStorageItemNames.TOKEN, data?.token, { path: "/", expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) });
  cookies.set(localStorageItemNames.ROLE, data?.type, { path: "/", expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) });
  cookies.set(localStorageItemNames.NAME, data?.first_name, { path: "/", expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) });
};

export const removeUserCookies = () => {
  let cookies = new Cookies();
  cookies.remove(localStorageItemNames.USER_ID, { path: "/" });
  cookies.remove(localStorageItemNames.USER_EMAIL, { path: "/" });
  cookies.remove(localStorageItemNames.TOKEN, { path: "/" });
  cookies.remove(localStorageItemNames.ROLE, { path: "/" });
  cookies.remove(localStorageItemNames.NAME, { path: "/" });
};


